module.exports = require("./es-PR.d.ts");